import React from 'react';

function SplatterFour(props) {
    return(
<svg style={props.stylez} version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="128.000000pt" height="128.000000pt" viewBox="0 0 1280.000000 1280.000000"
 preserveAspectRatio="xMidYMid meet">
<metadata>
Created by potrace 1.15, written by Peter Selinger 2001-2017
</metadata>
<g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
stroke="none">
<path d="M9701 11083 c-46 -56 -38 -76 9 -26 22 23 40 47 40 53 0 20 -19 10
-49 -27z"/>
<path d="M7700 11099 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M9476 10921 c-4 -5 -2 -12 3 -15 5 -4 12 -2 15 3 4 5 2 12 -3 15 -5
4 -12 2 -15 -3z"/>
<path d="M6875 10870 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M9635 10740 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M8760 10679 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M6311 10574 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8478 10523 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6595 10450 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M6844 10285 c-7 -17 4 -37 17 -30 12 8 12 45 -1 45 -6 0 -13 -7 -16
-15z"/>
<path d="M6866 10211 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 -4 11 -6 11 -12 0z"/>
<path d="M7035 10180 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M7667 10183 c-4 -3 -7 -15 -7 -26 0 -16 3 -17 15 -7 8 7 15 19 15 26
0 15 -12 19 -23 7z"/>
<path d="M8010 10165 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5
0 -10 -7 -10 -15z"/>
<path d="M8255 10160 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z"/>
<path d="M7192 10135 c-14 -31 -15 -62 -3 -70 14 -8 51 44 51 71 0 33 -33 32
-48 -1z"/>
<path d="M8060 10090 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M7550 10070 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M8715 10070 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M8746 10011 c-10 -11 -28 -22 -41 -25 -24 -6 -41 -44 -25 -60 5 -5
20 4 37 21 15 17 38 36 51 42 24 13 30 41 9 41 -8 0 -22 -9 -31 -19z"/>
<path d="M4410 9979 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M6917 9963 c-11 -11 -8 -83 3 -83 6 0 10 19 8 45 -2 25 -3 45 -4 45
0 0 -4 -3 -7 -7z"/>
<path d="M9080 9680 c-21 -40 14 -55 46 -19 16 17 16 22 4 29 -23 15 -38 12
-50 -10z"/>
<path d="M8230 9670 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0
-15 -4 -15 -10z"/>
<path d="M8275 9661 c-7 -12 12 -24 25 -16 11 7 4 25 -10 25 -5 0 -11 -4 -15
-9z"/>
<path d="M7600 9650 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M8590 9639 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M8243 9591 c-33 -27 -79 -57 -104 -67 -49 -19 -89 -51 -89 -70 0 -7
9 -18 21 -25 17 -9 33 -7 80 10 72 27 114 19 138 -24 9 -17 35 -56 59 -87 23
-31 42 -65 42 -74 0 -9 10 -33 21 -54 32 -56 80 -62 119 -15 18 22 -6 98 -29
90 -22 -6 -51 19 -110 98 -76 102 -76 101 -51 159 11 27 22 61 23 76 2 23 -2
27 -29 30 -25 2 -43 -7 -91 -47z"/>
<path d="M6306 9611 c-4 -5 -2 -12 3 -15 5 -4 12 -2 15 3 4 5 2 12 -3 15 -5 4
-12 2 -15 -3z"/>
<path d="M9130 9479 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M6590 9420 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M3822 9399 c-51 -19 -10 -107 62 -134 84 -32 100 3 37 83 -42 53 -64
64 -99 51z"/>
<path d="M8595 9400 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M4601 9386 c-18 -21 -9 -51 14 -51 24 0 32 36 12 53 -11 10 -17 9
-26 -2z"/>
<path d="M7440 9114 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M5755 9100 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M9702 8979 c2 -6 8 -10 13 -10 5 0 11 4 13 10 2 6 -4 11 -13 11 -9 0
-15 -5 -13 -11z"/>
<path d="M7817 8823 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M6627 8743 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M6800 8729 c0 -25 33 -22 38 4 2 12 -3 17 -17 17 -15 0 -21 -6 -21
-21z"/>
<path d="M7545 8730 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M7630 8649 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M7955 8610 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6680 8590 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6895 8539 c-9 -14 -2 -20 14 -10 8 6 9 11 3 15 -6 3 -14 1 -17 -5z"/>
<path d="M7405 8500 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6946 8487 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M7990 8489 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M7125 8439 c-10 -15 3 -25 16 -12 7 7 7 13 1 17 -6 3 -14 1 -17 -5z"/>
<path d="M9195 8291 c-3 -5 8 -9 25 -9 21 1 27 4 18 9 -17 11 -35 11 -43 0z"/>
<path d="M9200 8240 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6580 8229 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M7315 8210 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4512 8179 c2 -7 10 -15 17 -17 8 -3 12 1 9 9 -2 7 -10 15 -17 17 -8
3 -12 -1 -9 -9z"/>
<path d="M8405 8170 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6705 8141 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z"/>
<path d="M8500 8090 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"/>
<path d="M7240 8082 c-8 -3 -36 -24 -62 -47 -53 -48 -85 -55 -247 -55 -103 0
-261 31 -282 56 -15 18 -53 18 -68 0 -16 -19 2 -30 35 -22 14 4 30 3 37 -1 31
-19 145 -52 200 -58 34 -4 66 -10 72 -13 5 -3 44 -7 85 -8 41 -1 108 -5 148
-9 58 -6 77 -4 97 9 31 20 67 20 178 0 80 -15 89 -15 112 0 29 19 34 62 8 70
-10 3 -54 5 -98 5 -91 -1 -127 10 -150 45 -17 26 -41 36 -65 28z"/>
<path d="M7903 8023 c-16 -6 -17 -29 -3 -38 11 -7 40 12 40 25 0 11 -22 18
-37 13z"/>
<path d="M7210 7899 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M6903 7869 c9 -5 17 -20 17 -33 0 -26 -167 -239 -180 -231 -5 3 -14
-4 -20 -15 -6 -11 -19 -20 -28 -20 -10 0 -23 -5 -29 -11 -18 -18 -43 -2 -44
28 -1 15 -3 21 -6 12 -5 -21 -45 -29 -70 -16 -13 7 -12 3 6 -17 14 -14 30 -26
37 -26 10 0 11 -6 4 -25 -17 -46 9 -74 31 -33 l12 22 12 -25 c7 -13 15 -50 18
-81 4 -49 3 -56 -12 -51 -12 4 -13 2 -3 -4 7 -5 15 -27 19 -49 3 -21 11 -42
17 -46 8 -5 7 -13 -2 -28 -11 -17 -9 -24 9 -43 21 -22 21 -46 4 -107 -4 -14 2
-8 14 14 11 21 18 43 15 47 -12 19 13 7 37 -19 46 -48 67 -103 79 -209 6 -56
8 -113 5 -126 -7 -25 -121 -114 -132 -103 -3 3 -14 -5 -25 -17 l-19 -22 5 38
c5 36 4 37 -17 25 -14 -7 -17 -13 -9 -16 15 -5 15 -42 -1 -62 -16 -21 -68 -60
-78 -60 -16 0 -9 88 10 132 26 62 15 79 -47 71 -60 -7 -77 10 -69 65 6 34 5
35 -8 18 -8 -11 -15 -27 -15 -36 0 -22 50 -72 66 -66 8 3 14 -1 14 -8 0 -17
-47 -49 -60 -41 -5 3 -16 -5 -24 -17 -12 -17 -13 -24 -3 -30 7 -4 16 -2 22 5
6 6 27 13 48 13 l39 2 -23 -24 c-25 -27 -20 -66 6 -44 11 9 12 16 5 25 -10 12
-4 25 12 25 12 0 9 -72 -5 -97 -7 -12 -30 -41 -52 -64 -51 -55 -172 -206 -177
-221 -3 -8 -17 -4 -41 11 -21 12 -34 27 -31 33 10 16 13 108 3 108 -5 0 -9 7
-9 15 0 18 -35 55 -52 55 -8 0 -14 15 -15 35 -2 19 1 35 6 35 18 0 40 -30 34
-46 -8 -22 26 -45 49 -31 12 8 14 13 5 19 -24 14 2 19 47 7 26 -6 49 -9 52 -7
3 3 -16 11 -42 17 -60 15 -106 39 -99 51 3 5 12 7 20 3 8 -3 15 0 15 6 0 6 -4
11 -10 11 -5 0 -10 8 -10 18 -1 14 -4 13 -20 -6 -18 -22 -48 -23 -35 -1 4 5 2
9 -4 9 -10 0 -31 -61 -31 -92 0 -10 -4 -18 -10 -18 -5 0 -10 -6 -10 -13 0 -9
-11 -14 -32 -13 -21 1 -32 6 -31 14 2 6 -3 12 -11 12 -8 0 -13 -8 -12 -17 0
-10 -10 -21 -27 -27 -24 -9 -30 -7 -38 7 -6 9 -17 17 -26 17 -9 0 -21 7 -27
16 -11 14 -96 58 -96 49 0 -3 18 -14 40 -25 49 -25 50 -30 5 -20 -40 9 -61 24
-77 54 -10 19 -10 20 7 6 11 -9 4 10 -19 53 -20 37 -34 67 -31 67 3 0 -9 20
-27 44 -18 25 -46 68 -63 97 -16 29 -56 80 -87 113 -32 33 -58 68 -58 79 0 10
-5 15 -10 12 -6 -4 -27 7 -48 22 -54 42 -82 58 -124 72 -21 7 -45 22 -53 34
-18 25 -19 18 -4 -16 7 -16 35 -36 82 -57 92 -42 152 -98 166 -156 13 -51 14
-154 2 -205 -8 -34 -6 -37 23 -51 86 -41 123 -60 146 -77 22 -17 23 -21 10
-38 -14 -17 -14 -17 3 -4 16 12 20 12 33 -1 31 -31 -27 -97 -65 -73 -6 3 -11
1 -11 -4 0 -6 -13 -11 -30 -11 -22 0 -40 11 -67 40 -21 22 -42 40 -46 40 -12
0 13 -42 40 -67 12 -12 23 -25 23 -28 0 -3 -22 -4 -50 -2 -58 5 -122 -20 -152
-59 -13 -15 -28 -24 -38 -21 -13 3 -16 0 -13 -14 7 -25 -9 -24 -24 1 -14 21
-7 54 9 44 7 -4 8 5 3 25 -4 19 -3 31 4 31 6 0 8 6 5 14 -3 8 0 25 6 38 11 22
10 22 -4 3 -8 -11 -19 -24 -23 -30 -4 -5 -8 -18 -9 -27 -3 -70 -3 -71 -19 -58
-9 7 -20 32 -26 56 -6 24 -15 44 -20 44 -5 0 -14 12 -19 28 -6 15 -15 36 -20
47 -36 75 -71 200 -112 390 -5 28 -15 61 -20 75 -6 14 -12 70 -14 126 -3 84
-7 108 -27 143 -25 44 -62 73 -109 84 -14 4 -33 10 -42 13 -11 4 -16 1 -16
-10 0 -9 6 -16 14 -16 16 0 77 -55 100 -91 18 -29 34 -73 46 -134 19 -91 40
-183 54 -235 24 -90 58 -214 64 -228 3 -9 -7 -7 -32 6 -86 46 -171 -30 -216
-193 -31 -112 -41 -121 -157 -124 -79 -2 -93 -49 -43 -147 16 -32 30 -64 30
-70 0 -6 12 -21 26 -35 l26 -24 -26 58 c-14 32 -34 71 -46 87 -26 37 -27 96
-1 110 11 5 47 10 80 10 71 0 94 16 111 79 6 23 15 41 19 41 5 0 7 9 4 20 -14
55 70 173 132 186 66 13 127 -71 150 -205 5 -32 21 -58 60 -102 37 -42 54 -70
59 -98 8 -51 61 -93 125 -99 46 -4 94 -23 106 -42 4 -6 0 -21 -9 -33 -9 -12
-23 -32 -32 -44 -15 -21 -15 -23 0 -29 10 -4 32 1 50 11 37 20 83 15 93 -10
16 -43 -39 -103 -109 -119 -24 -5 -28 -1 -55 54 -15 33 -34 62 -41 65 -15 5
-92 -50 -92 -66 0 -11 -54 0 -58 13 -7 17 -20 7 -15 -12 5 -17 0 -20 -31 -20
-19 0 -54 -8 -78 -17 -41 -16 -42 -16 -57 7 -9 12 -42 51 -74 86 -43 46 -58
69 -55 86 4 29 50 32 84 5 17 -13 24 -15 24 -5 0 13 -43 38 -67 38 -22 0 -14
21 21 56 35 35 48 64 36 83 -16 28 -56 -20 -114 -135 -17 -34 -34 -54 -48 -57
-13 -3 -66 -13 -118 -22 -179 -33 -220 -57 -220 -130 0 -52 33 -98 85 -117 19
-6 35 -16 35 -21 0 -4 4 -5 10 -2 13 8 90 -13 90 -25 0 -6 -15 -11 -32 -12
-18 -1 -49 -3 -68 -4 -19 -1 -42 4 -50 11 -31 25 -44 27 -23 4 12 -13 22 -28
22 -33 -1 -5 18 -19 42 -30 23 -12 43 -25 43 -31 1 -12 -116 -36 -129 -26 -5
5 -22 11 -37 15 -33 8 -85 -31 -75 -57 8 -21 72 -33 100 -19 12 6 51 13 87 16
36 3 79 8 95 11 26 6 32 2 48 -23 9 -17 17 -32 17 -34 0 -2 -35 -4 -77 -4
-100 -2 -163 -13 -163 -28 0 -7 -9 -31 -20 -54 -11 -22 -20 -46 -20 -53 0 -6
-6 -9 -12 -7 -7 3 -31 -1 -53 -8 l-40 -13 52 6 c49 5 52 4 66 -23 40 -76 127
-110 216 -84 42 12 46 8 29 -19 -8 -13 -19 -19 -30 -15 -14 4 -18 0 -18 -19 0
-14 7 -30 15 -37 9 -7 14 -19 11 -26 -3 -8 0 -13 7 -11 13 2 11 -44 -2 -53 -4
-3 -10 -13 -14 -22 -7 -21 -27 -24 -27 -5 0 8 -3 7 -10 -3 -6 -9 -5 -19 2 -28
9 -10 6 -14 -11 -19 -14 -4 -20 -11 -17 -20 3 -8 6 -17 6 -19 0 -2 8 -4 18 -4
10 0 29 -11 41 -24 22 -23 22 -25 6 -50 -10 -14 -21 -26 -26 -26 -5 0 -9 -4
-9 -9 0 -6 15 -5 37 1 30 8 43 6 79 -11 23 -12 47 -28 54 -36 7 -8 17 -12 23
-8 5 3 29 8 52 9 63 6 68 -26 22 -128 -22 -49 -47 -64 -47 -28 0 11 -4 20 -10
20 -5 0 -9 -10 -7 -23 1 -12 -3 -21 -9 -20 -6 1 -53 4 -105 7 -98 4 -129 11
-129 28 0 6 -7 8 -15 4 -13 -4 -13 -2 -5 14 7 12 7 27 0 45 -5 14 -10 40 -10
57 0 30 -28 85 -62 122 -16 17 -22 18 -55 8 -21 -7 -54 -11 -73 -9 -34 2 -35
1 -38 -35 -3 -30 3 -42 32 -72 20 -19 54 -40 75 -47 47 -14 52 -24 57 -101 4
-64 -9 -75 -43 -39 -10 10 -34 26 -53 36 -19 10 -38 22 -41 27 -4 6 -16 7 -27
4 -26 -9 -22 -22 30 -99 31 -47 37 -61 27 -73 -6 -8 -18 -14 -26 -14 -15 0
-14 -34 2 -90 3 -8 0 -21 -4 -29 -8 -12 -12 -13 -26 -1 -10 8 -19 10 -25 4
-21 -21 -80 -2 -128 41 -41 37 -45 44 -33 59 12 14 12 16 0 11 -9 -3 -29 10
-49 30 -32 34 -34 37 -22 68 7 17 18 120 24 228 14 225 9 255 -46 308 -30 29
-40 33 -78 31 -88 -5 -131 0 -175 21 -24 12 -41 25 -36 29 4 4 35 11 68 14
149 16 224 48 236 102 5 25 46 104 54 104 1 0 22 -8 46 -19 24 -10 67 -21 94
-24 37 -4 44 -3 27 4 -13 5 -39 11 -57 13 -34 4 -95 32 -95 43 0 3 15 29 33
57 62 95 97 181 114 286 16 89 16 102 3 110 -42 26 -132 -9 -179 -70 -15 -19
-45 -75 -66 -125 -21 -49 -41 -94 -45 -100 -3 -5 -12 -30 -19 -55 -23 -81
-126 -210 -168 -210 -7 0 -42 -10 -79 -22 -53 -17 -70 -19 -85 -10 -15 10 -19
10 -17 0 5 -20 -134 -93 -217 -114 -257 -67 -324 -84 -352 -93 -18 -5 -33 -8
-33 -6 0 2 -18 -2 -41 -10 -22 -8 -70 -18 -105 -21 -94 -10 -98 -16 -89 -139
11 -133 11 -224 1 -316 l-9 -75 53 -40 c28 -21 63 -49 77 -62 14 -13 27 -21
30 -18 3 3 -20 29 -51 59 -65 61 -67 74 -31 162 27 65 31 133 14 200 -14 56
-11 133 8 161 8 13 30 31 47 38 109 49 453 146 519 146 16 0 36 4 46 9 9 5 46
12 82 16 35 3 82 8 104 10 48 5 70 -8 145 -81 30 -30 72 -71 93 -92 49 -48 70
-96 62 -142 -7 -40 -51 -120 -65 -120 -6 0 -10 -11 -10 -25 0 -44 -37 -125
-83 -178 -24 -29 -54 -72 -67 -97 -25 -50 -101 -162 -136 -200 -30 -33 -54
-92 -54 -133 0 -45 8 -50 40 -27 37 26 66 25 84 -2 21 -32 14 -148 -14 -220
-18 -50 -32 -66 -92 -113 -75 -58 -99 -66 -120 -37 -18 25 -48 36 -48 17 0 -8
-12 -36 -28 -62 -15 -26 -38 -72 -52 -101 -22 -49 -23 -56 -9 -80 8 -15 33
-37 54 -49 83 -47 80 -47 155 0 178 109 256 204 298 364 14 51 21 64 44 74 47
19 88 74 88 118 0 24 8 48 21 65 18 22 28 26 74 26 57 0 105 14 117 33 12 20
62 -5 73 -38 11 -31 42 -83 61 -100 6 -5 20 -27 32 -48 17 -30 19 -43 11 -63
-11 -31 -4 -60 16 -68 24 -9 45 4 51 33 10 41 21 48 63 45 66 -4 83 4 80 40
-3 36 43 112 85 140 35 22 59 69 44 84 -9 9 -7 17 7 32 16 18 17 20 2 14 -13
-5 -17 -1 -17 18 0 18 13 31 55 56 30 18 61 42 69 54 13 19 18 20 45 9 16 -7
43 -25 60 -40 28 -25 36 -27 74 -20 23 4 47 8 52 9 6 0 16 4 24 9 12 8 9 15
-17 39 -18 17 -32 25 -32 20 0 -6 -7 -8 -15 -4 -8 3 -15 1 -15 -4 0 -21 -20
-9 -21 13 -1 20 -2 20 -12 -5 -6 -16 -14 -28 -18 -28 -8 0 -79 102 -79 114 0
6 -9 29 -21 53 -17 34 -26 43 -47 43 l-26 0 27 -27 c21 -23 26 -39 29 -92 l3
-64 -40 -29 c-50 -35 -105 -48 -105 -24 0 9 -6 17 -12 18 -51 6 -78 18 -78 34
0 8 -3 14 -8 14 -4 0 -8 19 -8 41 -1 23 -6 44 -12 48 -6 4 -11 15 -11 26 0 11
-1 27 -2 35 -1 8 1 29 5 47 l8 32 82 -4 c198 -12 204 -13 217 -50 9 -24 20
-35 41 -39 16 -3 27 -10 24 -15 -3 -4 -17 -6 -31 -3 -14 2 -25 0 -25 -6 0 -17
29 -22 55 -10 30 14 56 -3 52 -35 -1 -16 4 -23 21 -25 12 -2 22 1 22 7 0 7 17
9 48 6 95 -10 107 -14 124 -45 9 -17 23 -30 30 -30 10 0 10 2 -1 9 -27 17 7
47 88 79 44 18 84 32 89 32 15 0 35 29 53 74 14 34 22 42 48 46 18 3 30 10 29
15 -2 6 -7 9 -12 7 -5 -2 -6 4 -3 13 4 8 -3 23 -14 34 -15 14 -17 21 -8 26 19
12 201 57 232 57 15 1 27 6 27 14 0 7 23 25 50 40 28 15 50 30 50 34 0 3 15
28 32 56 18 27 33 56 34 64 0 8 2 22 3 30 1 8 17 25 37 38 36 23 42 50 9 44
-10 -2 -14 1 -10 7 3 6 15 11 26 11 18 0 19 2 5 15 -14 14 -18 13 -45 -17 -25
-27 -29 -29 -25 -11 9 33 44 67 57 54 6 -6 19 -11 29 -11 11 0 23 -11 28 -25
9 -23 15 -25 72 -25 69 0 138 -15 138 -30 0 -6 6 -10 12 -10 7 0 43 -12 80
-26 82 -33 112 -62 111 -108 -1 -30 6 -40 66 -88 76 -61 90 -77 91 -100 0 -9
11 -25 25 -35 13 -10 45 -33 70 -52 40 -29 54 -34 103 -34 31 0 76 5 99 12 40
11 113 68 113 88 0 5 -35 9 -77 9 -101 0 -220 42 -229 80 -12 46 4 72 68 114
34 22 67 40 72 40 6 0 45 21 86 45 110 67 150 58 150 -32 0 -61 -10 -81 -42
-92 -41 -15 -71 -14 -62 1 4 7 3 8 -5 4 -6 -4 -19 -2 -27 5 -33 27 -22 -1 16
-42 23 -24 48 -56 56 -71 19 -36 47 -36 74 -1 20 26 22 35 16 118 -12 167 -11
164 -83 225 -35 30 -71 66 -79 80 -9 14 -50 50 -91 80 -42 30 -85 66 -97 78
-12 13 -33 35 -48 50 -28 25 -40 82 -17 82 7 0 9 19 5 57 -3 31 -7 58 -9 59
-6 6 -67 -41 -67 -52 0 -6 -8 -18 -19 -28 -22 -20 -35 -8 -45 39 -6 29 -4 31
40 45 54 18 61 33 19 40 -24 4 -29 10 -27 28 2 12 -2 22 -8 22 -7 0 -9 8 -5
20 9 28 -13 54 -31 39 -17 -14 -19 -49 -3 -49 7 0 0 -9 -14 -20 -14 -11 -30
-20 -36 -20 -17 0 -13 68 4 78 9 4 17 19 20 33 2 13 16 34 30 46 17 15 21 24
13 29 -11 7 -41 -22 -51 -49 -3 -9 -10 -7 -23 6 -18 17 -18 19 -2 28 19 11 13
39 -8 39 -10 0 -13 7 -9 23 3 12 7 32 8 44 2 31 15 18 23 -23 3 -19 15 -39 25
-45 15 -7 17 -6 13 6 -11 28 6 65 39 85 36 22 32 26 -8 8 -19 -8 -31 -8 -51 0
l-25 12 48 37 c26 20 53 42 58 48 23 27 106 87 112 82 3 -4 12 1 19 11 7 9 16
17 21 17 4 0 24 10 43 22 19 11 55 27 80 34 41 12 114 67 212 161 32 31 32 33
13 -55 -16 -76 -14 -89 21 -112 27 -17 31 -10 9 19 -26 34 -12 155 26 226 24
44 24 53 -1 40 -11 -6 -25 -8 -30 -5 -6 4 -13 -2 -17 -12 -27 -76 -153 -183
-153 -131 0 14 147 158 161 158 5 0 9 7 9 16 0 10 -24 -7 -66 -45 -51 -46 -70
-58 -82 -51 -10 5 -25 11 -34 14 -11 3 -18 15 -18 30 0 21 -6 26 -35 32 -23 4
-41 2 -50 -6 -32 -27 -24 0 19 61 99 140 136 199 136 215 0 10 34 52 75 95 72
74 92 109 60 109 -8 0 -29 -13 -47 -28 -53 -44 -105 -81 -119 -84 -8 -2 -18
-8 -24 -14 -5 -6 -26 -20 -45 -30 -19 -11 -52 -31 -73 -46 -47 -33 -67 -27
-68 21 -3 102 -6 130 -19 178 -11 44 -11 54 0 68 12 15 12 16 -4 13 -13 -2
-21 8 -32 37 -19 55 -18 62 14 71 23 6 24 8 7 12 -11 2 -30 16 -41 30 -15 19
-31 26 -55 27 -31 0 -34 3 -37 35 -2 19 -8 40 -14 47 -5 7 -8 27 -7 45 2 18
-3 52 -10 76 -10 37 -10 47 4 68 8 13 20 24 26 24 21 0 90 62 114 104 13 23
43 57 66 76 82 69 82 70 66 88 -8 9 -17 25 -20 35 -4 9 -14 17 -24 17 -17 -1
-17 -1 0 -11z m-1290 -1019 c12 -19 22 -51 22 -70 0 -29 4 -35 22 -35 12 0 29
-9 37 -20 20 -26 20 -39 0 -31 -15 6 -15 4 -3 -11 8 -10 22 -24 32 -31 9 -7
15 -18 11 -23 -3 -5 0 -17 7 -25 25 -31 -3 -25 -69 14 -77 46 -97 65 -89 86 3
8 0 17 -8 20 -8 3 -16 28 -19 63 -4 32 -9 78 -11 102 l-5 45 26 -25 c14 -13
35 -39 47 -59z m1547 71 c0 -6 -20 -31 -45 -58 -30 -31 -43 -53 -40 -65 9 -26
-30 -94 -116 -200 -44 -54 -79 -103 -79 -109 0 -6 -7 -9 -15 -5 -8 3 -14 2
-14 -2 1 -4 0 -10 -1 -14 -1 -5 -3 -11 -4 -15 -5 -23 -46 -69 -96 -108 -63
-48 -122 -68 -190 -63 l-44 3 84 67 c47 38 94 68 105 69 12 0 15 3 7 6 -10 4
-4 16 21 42 46 47 102 147 111 197 4 21 9 47 12 57 5 16 192 146 211 147 5 1
26 14 48 30 46 33 45 33 45 21z m-596 -208 c-5 -45 -9 -49 -29 -33 -8 7 -15 9
-15 5 0 -5 -3 -6 -6 -2 -9 8 28 67 43 67 8 0 11 -12 7 -37z m251 -35 c-14 -65
-63 -153 -111 -200 -53 -52 -101 -68 -96 -33 3 18 1 18 -16 -3 -10 -13 -21
-20 -25 -16 -9 10 33 55 44 48 5 -3 6 1 3 9 -3 8 10 31 30 53 20 22 36 46 36
54 -1 9 -6 5 -15 -10 -11 -19 -14 -21 -15 -8 0 22 56 74 118 110 26 15 48 28
50 28 2 0 1 -15 -3 -32z m-175 -103 c0 -28 -87 -145 -107 -145 -7 0 -12 -4
-10 -8 1 -4 -22 -43 -51 -85 l-53 -77 -51 0 c-48 0 -50 1 -36 18 8 9 38 46 67
81 67 81 77 92 85 84 3 -4 6 1 6 10 0 9 30 41 68 71 63 52 82 64 82 51z m-404
-72 c-10 -10 -19 5 -10 18 6 11 8 11 12 0 2 -7 1 -15 -2 -18z m847 -84 c-10
-16 -21 -29 -25 -29 -4 0 -8 -8 -8 -17 0 -19 -88 -94 -152 -131 l-37 -21 21
52 c12 29 24 71 27 94 7 50 52 93 76 73 8 -6 23 -9 35 -5 14 4 20 2 20 -9 0
-8 5 -18 12 -22 8 -5 9 -2 5 11 -9 22 9 46 29 38 12 -4 11 -10 -3 -34z m-898
-9 c25 -23 34 -73 16 -84 -4 -3 -18 5 -30 18 -22 23 -22 25 -4 34 10 6 15 13
12 16 -3 3 -14 0 -23 -7 -15 -11 -17 -17 -7 -35 15 -28 3 -28 -49 -2 -22 11
-40 27 -40 35 0 9 -6 12 -16 8 -12 -4 -15 -1 -12 13 2 10 11 19 20 19 9 0 20
3 24 7 14 15 85 0 109 -22z m711 -14 c4 -16 -6 -55 -27 -110 -31 -82 -36 -89
-97 -134 -36 -26 -69 -46 -74 -44 -6 1 -12 -6 -15 -17 -6 -23 -49 -55 -63 -46
-6 3 -7 -1 -4 -9 7 -18 3 -19 -20 -10 -9 3 -16 15 -16 25 0 10 -5 19 -11 19
-6 0 10 21 35 46 25 25 46 51 46 57 0 21 50 87 65 87 10 0 15 -10 15 -30 0
-16 4 -30 9 -30 5 0 7 19 4 43 -4 40 -2 44 43 77 26 19 58 46 73 58 l26 24
-29 -21 c-39 -29 -48 -16 -11 14 38 31 43 31 51 1z m-326 6 c0 -5 -9 -17 -20
-27 -11 -10 -20 -26 -20 -36 0 -12 -15 -26 -40 -39 -22 -11 -40 -16 -40 -10 0
5 5 10 10 10 6 0 10 7 10 15 0 8 18 33 40 55 38 38 60 50 60 32z m60 4 c0 -8
-61 -48 -65 -44 -10 9 27 48 46 48 10 0 19 -2 19 -4z m120 -101 c-13 -14 -28
-25 -34 -25 -11 1 40 50 51 50 4 0 -4 -11 -17 -25z m-901 -46 c-13 -26 -23
-18 -14 10 3 12 11 19 16 16 5 -4 5 -14 -2 -26z m421 -1 c0 -13 -23 -5 -28 10
-2 7 2 10 12 6 9 -3 16 -11 16 -16z m325 3 c-3 -5 -1 -12 5 -16 6 -3 13 1 16
9 6 16 54 23 54 9 0 -24 -106 -113 -133 -113 -8 0 -22 -11 -30 -24 -18 -27
-66 -40 -84 -23 -19 19 -27 67 -12 67 12 0 12 2 0 9 -18 11 -7 43 21 60 19 12
58 19 156 30 7 0 11 -3 7 -8z m-205 -33 c0 -5 -5 -6 -11 -3 -6 4 -16 -1 -23
-11 -7 -9 -18 -14 -24 -10 -18 11 -14 34 6 38 23 5 52 -2 52 -14z m-180 -16
c15 10 22 10 31 1 10 -10 6 -18 -16 -35 -16 -13 -36 -30 -43 -39 -8 -10 -23
-14 -34 -11 -17 4 -19 11 -14 40 4 25 2 32 -5 25 -6 -6 -13 -33 -16 -60 -7
-79 -12 -93 -28 -87 -11 4 -13 2 -9 -9 3 -9 -7 -23 -28 -37 -18 -13 -40 -32
-49 -43 -9 -10 -36 -29 -60 -41 -38 -19 -47 -29 -63 -78 -17 -49 -27 -60 -71
-87 -28 -17 -61 -31 -72 -31 -12 0 -38 16 -59 35 -20 19 -43 35 -50 35 -27 0
-13 33 31 77 25 24 45 48 45 53 0 8 36 24 50 22 3 0 10 4 17 10 7 5 25 7 40 4
19 -4 38 0 58 14 17 11 41 20 55 20 36 0 66 24 73 58 3 16 25 59 48 96 34 53
48 66 68 66 14 0 32 4 40 9 9 6 19 4 28 -5 11 -11 18 -11 33 -2z m364 -96
c-46 -42 -62 -52 -83 -48 -25 5 -24 6 14 23 22 10 58 36 80 59 22 22 41 36 43
30 2 -6 -22 -34 -54 -64z m-202 -74 c-58 -52 -62 -55 -62 -38 0 27 -20 28 -30
2 -11 -30 -8 -29 -48 -15 -30 10 -30 10 -14 39 17 29 61 48 81 36 13 -8 45 60
37 79 -4 10 2 19 17 24 20 8 24 4 39 -43 l17 -51 -37 -33z m-222 43 c-7 -8
-16 -15 -21 -15 -5 0 -6 7 -3 15 4 8 13 15 21 15 13 0 13 -3 3 -15z m74 -13
c2 -4 -5 -23 -16 -40 -20 -33 -57 -41 -65 -16 -10 30 65 82 81 56z m273 -49
c-11 -12 -17 -13 -17 -5 0 7 -5 10 -11 6 -8 -4 -7 -9 2 -15 11 -7 8 -14 -13
-36 l-28 -28 0 32 c0 37 55 92 74 73 7 -7 5 -15 -7 -27z m-47 17 c0 -5 -4 -10
-10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-30 -4 c0 -3 -5
-17 -12 -33 -6 -15 -10 -35 -9 -44 1 -8 -12 -33 -29 -55 -57 -71 -109 -81
-106 -21 1 27 -3 32 -22 32 -13 0 -28 9 -34 19 -8 15 -7 17 8 12 57 -16 77
-18 100 -6 13 8 24 19 24 26 0 18 49 74 66 74 8 0 14 -2 14 -4z m-944 -99 l13
-36 -66 -22 c-71 -23 -94 -17 -73 20 6 12 9 30 5 39 -3 11 3 27 14 39 18 19
23 20 57 8 30 -10 41 -21 50 -48z m1026 36 c-4 -27 -67 -103 -85 -103 -4 0
-25 -12 -45 -27 -23 -17 -5 7 48 64 47 50 86 92 86 92 1 1 -1 -11 -4 -26z m46
15 c-3 -7 -12 -14 -21 -16 -12 -2 -15 1 -11 12 7 19 38 22 32 4z m-438 -7 c0
-5 -7 -12 -16 -15 -24 -9 -28 -7 -14 9 14 17 30 20 30 6z m23 -58 c-9 -16 -31
-41 -48 -56 -30 -28 -30 -28 -33 -6 -2 12 2 26 10 30 7 5 9 9 5 9 -16 0 49 49
66 50 17 0 17 -1 0 -27z m417 -1 c0 -22 -35 -57 -48 -48 -5 3 -15 -1 -22 -9
-10 -12 -9 -15 4 -15 11 0 16 -9 16 -30 0 -16 5 -30 10 -30 19 0 10 -37 -12
-47 -47 -23 -57 -23 -60 0 -2 16 -9 21 -26 20 -16 -2 -22 2 -22 17 0 26 -12
26 -28 0 -13 -21 -42 -28 -42 -10 0 6 7 10 15 10 7 0 18 6 22 14 14 24 66 47
75 33 5 -8 8 -6 8 6 0 21 77 107 96 107 8 0 14 -8 14 -18z m-1265 -42 c0 -29
-4 -35 -22 -35 -25 -1 -63 -32 -63 -51 0 -8 -11 -16 -25 -20 -14 -3 -25 -10
-25 -16 0 -5 -4 -7 -9 -4 -14 9 -41 -4 -41 -19 0 -19 -13 -25 -30 -15 -11 7
-10 13 5 37 11 15 19 36 20 45 0 10 4 17 9 17 5 0 21 19 37 42 33 50 49 59
104 56 39 -2 40 -3 40 -37z m904 16 c17 -30 9 -43 -26 -44 -42 0 -45 7 -23 39
26 35 33 36 49 5z m-859 -40 c0 -6 -7 -2 -15 8 -8 11 -15 25 -15 30 0 6 7 2
15 -8 8 -11 15 -25 15 -30z m700 5 c0 -10 -7 -24 -15 -31 -20 -17 -32 13 -13
34 18 21 28 20 28 -3z m544 -10 c-10 -10 -22 -17 -25 -15 -4 2 -10 -3 -13 -12
-4 -10 -2 -13 6 -8 7 4 8 3 4 -4 -12 -20 -33 -2 -28 23 3 17 12 25 31 28 14 2
30 5 35 6 5 0 1 -7 -10 -18z m-654 -12 c-7 -11 -14 -18 -17 -15 -8 8 5 36 17
36 7 0 7 -6 0 -21z m200 -3 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11
10 11 6 0 10 -2 10 -4z m479 -19 c8 -10 6 -24 -8 -53 -14 -28 -16 -44 -9 -57
5 -10 8 -20 6 -21 -36 -27 -59 -36 -93 -35 -26 1 -31 3 -15 6 14 2 39 15 55
29 l30 25 -32 -5 c-25 -4 -33 -2 -33 10 0 8 7 17 15 20 8 4 15 14 15 24 0 19
36 70 50 70 4 0 13 -6 19 -13z m-319 -5 c0 -5 -11 -14 -25 -20 -24 -11 -25
-10 -15 8 10 20 40 28 40 12z m-250 -12 c0 -5 -8 -10 -17 -10 -15 0 -16 2 -3
10 19 12 20 12 20 0z m270 -21 c-12 -16 -25 -28 -28 -25 -5 6 36 56 45 56 3 0
-5 -14 -17 -31z m-377 -14 c-5 -13 -23 -22 -23 -11 0 15 14 35 21 31 4 -3 6
-12 2 -20z m252 6 c3 -5 1 -13 -5 -16 -15 -9 -43 3 -35 15 8 13 32 13 40 1z
m-1337 -20 c24 -2 12 -18 -27 -35 -28 -13 -43 -15 -57 -8 -11 6 -27 13 -36 16
-10 3 -18 10 -18 15 0 15 42 19 138 12z m1312 -31 c0 -11 -40 -13 -65 -3 -15
5 -14 8 6 19 24 13 59 3 59 -16z m40 20 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10
3 6 8 10 11 10 2 0 4 -4 4 -10z m84 -15 c-8 -20 18 -20 58 1 34 17 52 8 46
-22 -5 -28 -112 -33 -140 -7 -18 16 -18 18 -2 30 24 18 45 16 38 -2z m-1278
-5 c24 0 15 -31 -17 -61 -37 -34 -32 -33 -75 -13 -40 19 -43 31 -10 40 14 3
32 15 42 25 10 11 24 17 32 14 7 -3 20 -5 28 -5z m613 -41 c15 -45 14 -118 -3
-135 -8 -7 -16 -18 -18 -24 -4 -13 -78 -22 -78 -9 0 11 43 55 80 82 16 11 21
20 13 23 -7 3 -9 12 -6 20 3 8 1 14 -5 14 -5 0 -12 -7 -16 -15 -8 -22 -37 -19
-30 3 27 81 45 93 63 41z m821 17 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6
5 11 10 11 6 0 10 -2 10 -4z m-505 -26 c-3 -5 -13 -10 -21 -10 -8 0 -12 5 -9
10 3 6 13 10 21 10 8 0 12 -4 9 -10z m754 -11 c34 -12 42 -29 14 -29 -27 0
-89 -40 -75 -49 15 -9 -43 -91 -64 -91 -19 0 -54 36 -54 55 0 29 52 95 74 95
12 0 31 7 42 15 23 18 24 18 63 4z m-1814 -39 c21 -17 45 -28 54 -25 9 2 22 0
30 -4 12 -8 12 -12 2 -25 -19 -22 -57 -20 -74 4 -8 11 -16 17 -19 14 -8 -8
-49 47 -42 57 7 12 7 13 49 -21z m1525 0 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11
10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m-841 -46 c-13 -14 -25 -20 -27 -14 -7
20 7 40 29 40 l22 0 -24 -26z m865 -9 c13 -20 20 -23 40 -15 24 9 39 4 30 -11
-2 -4 -11 -6 -19 -2 -8 3 -15 0 -15 -6 0 -6 7 -11 16 -11 11 0 14 -8 12 -27
-2 -18 -9 -28 -19 -28 -9 0 -23 -6 -31 -12 -11 -10 -19 -9 -35 2 -19 14 -23
13 -39 -2 -10 -10 -25 -19 -33 -20 -52 -7 -104 -22 -110 -31 -10 -16 -61 -26
-61 -12 0 26 35 68 68 81 19 8 46 29 60 47 27 36 70 62 90 55 6 -3 12 0 12 6
0 19 17 12 34 -14z m256 -42 c0 -18 -18 -16 -37 2 -12 13 -13 19 -3 30 11 13
14 13 26 -2 7 -10 14 -24 14 -30z m7 -29 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6
11 1 17 -2 13 -5z m-1694 -121 c-16 -6 -17 -24 -2 -20 6 1 13 -3 16 -10 5 -13
-64 -12 -85 1 -23 14 7 36 47 35 20 0 30 -3 24 -6z m104 -18 c48 -28 53 -44
23 -63 -21 -13 -49 -5 -78 24 -12 12 -7 64 6 64 3 0 25 -11 49 -25z m739 -111
c18 -12 23 -22 18 -37 -6 -20 -6 -20 10 -4 10 9 14 21 11 27 -3 5 -1 10 5 10
8 0 10 -9 5 -27 -13 -53 -56 -58 -103 -12 -18 17 -32 38 -32 45 0 20 55 18 86
-2z m-277 -3 c7 -5 12 -14 9 -21 -2 -7 -10 -4 -22 9 -19 21 -12 28 13 12z
m-339 -36 c-7 -9 -15 -13 -18 -10 -3 2 1 11 8 20 7 9 15 13 18 10 3 -2 -1 -11
-8 -20z m387 -27 c-7 -4 1 -8 17 -8 26 0 143 -35 156 -47 2 -2 -2 -8 -10 -14
-12 -7 -11 -10 7 -15 21 -6 21 -7 7 -47 -8 -23 -22 -52 -30 -65 -19 -28 -7
-45 26 -40 18 2 30 19 54 74 37 85 68 130 84 120 7 -4 12 -18 12 -31 0 -13 5
-27 10 -30 6 -3 10 -11 10 -16 0 -12 -101 -109 -115 -109 -5 0 -32 -20 -60
-45 -74 -66 -116 -93 -156 -100 -37 -7 -37 -7 -40 32 -5 48 0 75 12 68 5 -4 9
-1 9 4 0 6 -5 11 -11 11 -5 0 -7 5 -4 10 11 18 -21 11 -69 -15 -56 -30 -56
-30 -56 -8 0 9 -7 25 -16 34 -15 17 -15 21 1 55 l17 36 52 -6 c28 -4 67 -9 86
-12 22 -3 54 3 85 15 39 15 44 20 25 21 -15 0 -31 -5 -36 -10 -6 -6 -28 -11
-50 -13 -34 -2 -39 1 -42 21 -2 15 2 22 12 22 20 0 20 23 0 77 -9 23 -14 50
-10 59 6 16 8 15 20 -2 11 -14 11 -21 3 -26z m-589 -11 c26 -9 32 -16 32 -39
0 -26 -2 -28 -21 -17 -17 8 -20 8 -14 -1 9 -14 -18 -8 -77 17 -34 14 -36 17
-25 40 11 26 31 26 105 0z m-68 -68 c0 -4 -9 -9 -20 -12 -11 -3 -20 -11 -20
-19 0 -9 2 -10 8 -1 16 25 112 29 112 4 0 -13 -82 -72 -94 -68 -6 2 -14 14
-18 28 -6 20 -7 19 -4 -9 4 -43 -16 -59 -43 -36 -15 13 -18 22 -10 36 7 13 5
27 -8 49 -18 30 -18 31 5 49 22 18 25 18 58 3 19 -9 34 -20 34 -24z m1030 -77
c0 -5 -12 -14 -27 -21 -28 -13 -28 -13 -9 8 20 22 36 27 36 13z m-150 -122 c0
-5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m-1182
-566 c12 -8 22 -19 22 -23 0 -9 -150 -3 -160 6 -3 3 6 13 19 24 26 22 78 18
119 -7z m47 -155 c-12 -47 -75 -99 -119 -99 -33 0 -33 10 -1 40 40 37 29 44
-25 14 -41 -23 -52 -25 -65 -14 -11 9 -13 16 -5 24 13 13 13 29 0 21 -5 -3
-10 3 -10 14 0 16 6 21 26 21 24 0 25 -2 13 -17 -13 -17 -12 -17 6 -1 12 9 48
19 90 23 38 3 72 8 74 11 11 10 22 -15 16 -37z"/>
<path d="M6797 6470 c3 -11 9 -17 14 -15 10 7 1 35 -11 35 -5 0 -6 -9 -3 -20z"/>
<path d="M6620 6069 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M6187 6183 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M6060 6090 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10 5z"/>
<path d="M5580 5669 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M6320 5518 c-10 -19 -10 -21 1 -11 10 10 16 9 31 -4 10 -9 18 -12 18
-6 0 5 -9 18 -19 27 -19 17 -20 17 -31 -6z"/>
<path d="M5740 5053 c0 -4 5 -15 10 -23 8 -13 10 -13 10 2 0 9 -4 20 -10 23
-5 3 -10 3 -10 -2z"/>
<path d="M5635 4850 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M6740 7809 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M6076 7771 c-4 -5 -2 -12 3 -15 5 -4 12 -2 15 3 4 5 2 12 -3 15 -5 4
-12 2 -15 -3z"/>
<path d="M6150 7685 c-42 -15 -46 -26 -29 -77 16 -49 42 -68 94 -68 103 0 116
122 17 150 -20 5 -39 9 -42 9 -3 -1 -21 -7 -40 -14z"/>
<path d="M7213 7675 c-3 -9 -3 -19 1 -22 8 -9 37 18 30 28 -8 14 -24 11 -31
-6z"/>
<path d="M5530 7657 c0 -7 20 -23 45 -35 25 -12 48 -29 52 -38 3 -8 -6 -45
-20 -82 -40 -103 -41 -125 -3 -47 20 39 35 85 36 103 0 33 -29 72 -54 72 -7 0
-16 9 -19 20 -6 22 -37 28 -37 7z"/>
<path d="M6716 7422 c-3 -5 1 -9 9 -9 8 0 15 4 15 9 0 4 -4 8 -9 8 -6 0 -12
-4 -15 -8z"/>
<path d="M6580 7390 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6810 7345 c7 -9 15 -13 17 -11 7 7 -7 26 -19 26 -6 0 -6 -6 2 -15z"/>
<path d="M6522 7306 c7 -8 15 -12 17 -11 5 6 -10 25 -20 25 -5 0 -4 -6 3 -14z"/>
<path d="M6955 7290 c-27 -30 -12 -34 15 -5 13 14 19 25 13 25 -5 0 -18 -9
-28 -20z"/>
<path d="M6864 7230 c3 -14 6 -28 6 -32 0 -5 5 -8 10 -8 15 0 12 22 -7 45 -15
20 -15 19 -9 -5z"/>
<path d="M6627 7223 c-4 -3 -7 -13 -7 -21 0 -12 3 -12 15 -2 8 7 15 16 15 21
0 11 -14 12 -23 2z"/>
<path d="M4532 7204 c-31 -22 -53 -79 -54 -144 -1 -77 35 -144 113 -212 33
-29 69 -70 80 -90 22 -42 25 -110 7 -130 -31 -32 -58 -79 -58 -97 0 -51 66
-67 104 -26 45 48 54 233 16 305 -6 11 -8 26 -4 33 16 26 59 77 66 77 3 0 13
-12 20 -27 8 -16 19 -37 26 -48 6 -11 20 -42 31 -68 24 -56 52 -62 62 -12 7
42 -4 76 -37 112 -41 43 -84 107 -120 177 -35 68 -79 113 -139 145 -47 25 -82
27 -113 5z"/>
<path d="M6000 7190 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7182 7128 c-19 -19 -14 -30 8 -18 11 6 20 15 20 20 0 14 -14 12 -28
-2z"/>
<path d="M5693 7090 c-6 -15 -7 -34 -2 -41 6 -11 9 -10 15 4 3 10 4 21 0 24
-3 3 -1 12 5 19 5 7 6 15 1 17 -4 3 -13 -7 -19 -23z"/>
<path d="M6960 7060 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6425 7050 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6455 7040 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6388 7028 c-7 -16 7 -45 14 -32 3 5 2 18 -2 28 -5 16 -8 17 -12 4z"/>
<path d="M6683 6985 c0 -33 2 -45 4 -27 2 18 2 45 0 60 -2 15 -4 0 -4 -33z"/>
<path d="M5840 6976 c0 -8 7 -17 16 -20 9 -3 14 -11 12 -18 -4 -11 21 -42 57
-68 19 -13 19 -13 -1 10 -12 14 -32 44 -44 68 -24 42 -40 54 -40 28z"/>
<path d="M6917 6943 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M3078 6924 c-68 -24 -103 -51 -130 -100 -23 -41 -28 -61 -28 -124 0
-42 4 -80 10 -86 5 -5 15 -25 22 -44 19 -51 70 -128 88 -134 8 -2 35 -12 60
-22 29 -11 93 -20 179 -25 128 -7 137 -9 207 -45 66 -34 76 -36 98 -24 60 32
56 112 -7 124 -37 7 -57 36 -57 85 0 57 -45 187 -81 231 -72 90 -111 129 -147
146 -48 23 -171 33 -214 18z"/>
<path d="M5832 6915 c-15 -32 -15 -35 1 -35 6 0 12 13 13 30 1 36 0 37 -14 5z"/>
<path d="M6080 6916 c0 -8 5 -18 10 -21 6 -3 10 1 10 9 0 8 -4 18 -10 21 -5 3
-10 -1 -10 -9z"/>
<path d="M6440 6915 c6 -8 9 -19 5 -25 -3 -6 3 -10 14 -10 26 0 26 2 2 28 -20
24 -41 31 -21 7z"/>
<path d="M8225 6880 c-8 -13 4 -32 16 -25 12 8 12 35 0 35 -6 0 -13 -4 -16
-10z"/>
<path d="M6020 6871 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M6681 6864 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5780 6825 c0 -8 6 -15 14 -15 22 0 28 17 10 24 -22 9 -24 8 -24 -9z"/>
<path d="M5990 6833 c0 -6 11 -18 25 -27 23 -15 25 -15 25 0 0 10 -3 14 -7 11
-3 -4 -15 0 -25 10 -10 9 -18 11 -18 6z"/>
<path d="M6390 6820 c-9 -16 -8 -18 5 -14 8 4 15 12 15 20 0 20 -7 17 -20 -6z"/>
<path d="M6107 6816 c-3 -8 -2 -18 3 -21 13 -8 24 15 12 27 -6 6 -11 4 -15 -6z"/>
<path d="M6676 6799 c-3 -17 -5 -43 -5 -58 1 -14 5 -2 10 28 10 58 6 83 -5 30z"/>
<path d="M6737 6783 c-27 -85 -28 -99 -3 -46 32 68 39 93 28 93 -5 0 -16 -21
-25 -47z"/>
<path d="M4790 6809 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4050 6769 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4830 6749 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M5250 6740 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M7315 6650 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M5420 6625 c-13 -14 -19 -25 -14 -25 8 1 50 50 41 50 -2 0 -14 -11
-27 -25z"/>
<path d="M5850 6630 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6280 6632 c0 -5 9 -12 21 -15 13 -3 19 -1 16 6 -5 15 -37 22 -37 9z"/>
<path d="M6440 6589 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M6260 6570 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6395 6570 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M5340 6539 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M7715 6519 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"/>
<path d="M8140 6500 c0 -5 9 -10 21 -10 11 0 17 5 14 10 -3 6 -13 10 -21 10
-8 0 -14 -4 -14 -10z"/>
<path d="M9120 6470 c0 -19 3 -21 12 -12 9 9 9 15 0 24 -9 9 -12 7 -12 -12z"/>
<path d="M3840 6259 c0 -6 6 -9 14 -6 8 3 36 -18 68 -53 59 -62 105 -97 115
-86 8 7 -35 46 -51 46 -7 0 -36 25 -66 55 -52 52 -80 68 -80 44z"/>
<path d="M5281 6244 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4586 6207 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M5263 6178 c-15 -19 -23 -87 -12 -93 5 -4 9 -19 9 -35 0 -16 3 -31 8
-34 4 -2 3 27 -2 66 -7 51 -7 74 2 89 14 21 10 26 -5 7z"/>
<path d="M6917 6153 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M5356 6128 c-13 -18 -18 -19 -31 -8 -28 23 -15 1 18 -30 37 -35 70
-36 75 -3 4 28 -14 63 -33 63 -8 0 -21 -10 -29 -22z"/>
<path d="M6820 6131 c0 -12 6 -21 15 -21 8 0 15 4 15 9 0 5 -7 14 -15 21 -13
10 -15 9 -15 -9z"/>
<path d="M7850 6130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M5500 6110 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M7960 6109 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M8138 6103 c-43 -49 -48 -143 -8 -143 25 0 50 57 50 116 0 48 -15 57
-42 27z"/>
<path d="M7890 6100 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7353 6050 c11 -28 42 -49 54 -36 4 3 -1 6 -10 6 -9 0 -23 14 -32 30
-20 39 -27 39 -12 0z"/>
<path d="M6790 5980 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M7563 5968 c-25 -12 -29 -23 -13 -33 6 -3 10 -1 10 6 0 6 8 18 18 25
20 16 15 17 -15 2z"/>
<path d="M3865 5950 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M3341 5917 c-8 -11 -2 -21 27 -44 24 -20 60 -70 101 -144 34 -63 74
-127 88 -144 26 -30 26 -30 9 -2 -45 74 -76 129 -115 207 -48 93 -78 140 -90
140 -5 0 -14 -6 -20 -13z"/>
<path d="M10130 5874 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M6862 5864 c-22 -15 -30 -44 -13 -44 10 0 45 50 39 56 -2 2 -14 -3
-26 -12z"/>
<path d="M7465 5800 c-16 -16 -27 -31 -24 -33 2 -2 17 11 32 30 36 41 31 43
-8 3z"/>
<path d="M7253 5727 c-46 -46 -43 -57 17 -57 28 0 50 -2 50 -5 0 -3 -9 -15
-20 -27 -11 -12 -20 -34 -20 -50 0 -26 3 -28 40 -28 31 0 38 3 34 15 -5 13
-24 20 -46 16 -19 -3 -6 33 21 60 l29 29 -59 0 c-64 0 -72 8 -36 37 13 10 26
24 31 31 14 23 -9 11 -41 -21z"/>
<path d="M6830 5730 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M7690 5607 c27 -28 37 -30 90 -27 l35 2 -28 8 c-16 5 -35 6 -43 3 -8
-3 -22 1 -32 9 -32 28 -47 31 -22 5z"/>
<path d="M8183 5540 c-11 -16 -10 -18 1 -14 15 6 30 34 18 34 -4 0 -13 -9 -19
-20z"/>
<path d="M3016 5531 c-4 -5 -2 -12 3 -15 5 -4 12 -2 15 3 4 5 2 12 -3 15 -5 4
-12 2 -15 -3z"/>
<path d="M7800 5270 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0
-15 -4 -15 -10z"/>
<path d="M7840 5260 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M4373 5208 c-16 -26 -11 -43 14 -55 28 -14 110 -17 137 -7 22 8 10
24 -18 24 -12 0 -33 11 -46 25 -25 27 -73 34 -87 13z"/>
<path d="M4738 5178 c9 -9 15 -9 24 0 9 9 7 12 -12 12 -19 0 -21 -3 -12 -12z"/>
<path d="M6140 5100 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7048 4993 c-18 -15 -35 -28 -37 -30 -2 -2 -2 -5 0 -7 2 -2 22 11 43
30 47 40 42 46 -6 7z"/>
<path d="M6101 4986 c-9 -10 -8 -16 4 -26 8 -7 15 -19 15 -27 0 -8 5 -11 10
-8 8 5 8 11 1 19 -6 7 -8 22 -4 34 6 25 -8 29 -26 8z"/>
<path d="M6275 4940 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6950 4861 c0 -15 63 -37 67 -24 3 7 11 9 20 6 11 -4 14 -2 9 5 -4 7
-19 9 -36 5 -19 -3 -30 -1 -30 6 0 6 -7 11 -15 11 -8 0 -15 -4 -15 -9z"/>
<path d="M4939 4813 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M7792 4808 c5 -15 28 -18 29 -3 0 6 -7 12 -17 13 -10 3 -15 -1 -12
-10z"/>
<path d="M6100 4739 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M6852 4590 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M4710 4601 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M5910 4571 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M6740 4570 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M4373 4514 c6 -17 20 -41 29 -55 17 -24 17 -24 17 -2 1 29 -9 53 -21
53 -6 0 -17 8 -24 18 -12 14 -12 12 -1 -14z"/>
<path d="M3232 4508 c6 -18 25 -20 31 -3 5 10 0 15 -14 15 -12 0 -19 -5 -17
-12z"/>
<path d="M6821 4479 c-29 -75 -31 -78 -67 -72 -31 5 -35 2 -63 -43 -37 -61
-34 -57 -101 -130 -42 -46 -60 -76 -75 -124 -19 -59 -23 -64 -65 -83 -51 -23
-152 -115 -216 -199 -62 -80 -75 -165 -35 -228 18 -26 22 -4 6 33 -9 22 -12
48 -8 69 8 41 101 160 151 193 20 14 48 33 62 43 76 56 120 81 153 87 49 10
64 28 48 62 -10 22 -9 31 12 62 14 20 33 58 42 84 14 38 33 61 87 105 55 45
68 61 68 85 0 15 5 37 11 48 6 11 9 25 7 31 -2 6 -10 -4 -17 -23z m-231 -318
c-15 -28 -33 -27 -24 2 3 12 12 28 18 36 9 12 11 12 14 -2 2 -9 -2 -25 -8 -36z"/>
<path d="M6000 4480 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"/>
<path d="M3632 4378 c4 -29 34 -35 59 -12 29 26 23 34 -22 34 -36 0 -40 -2
-37 -22z"/>
<path d="M2783 4323 c-13 -2 -31 -15 -42 -29 -10 -13 -24 -24 -30 -24 -21 0
-33 -39 -21 -74 18 -56 -4 -170 -48 -246 -15 -24 -64 -82 -110 -129 -81 -80
-112 -128 -112 -169 0 -26 25 -45 49 -37 25 8 156 137 174 173 7 15 30 59 50
97 47 92 61 169 49 260 -9 64 -8 72 12 97 11 15 31 41 44 58 13 16 20 29 15
29 -4 -1 -18 -4 -30 -6z"/>
<path d="M7507 4323 c-4 -3 -7 -12 -7 -20 0 -15 26 -18 34 -4 7 11 -18 33 -27
24z"/>
<path d="M9155 4290 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M9772 4129 c2 -6 8 -10 13 -10 5 0 11 4 13 10 2 6 -4 11 -13 11 -9 0
-15 -5 -13 -11z"/>
<path d="M5523 3495 c-32 -22 -55 -105 -44 -156 9 -40 51 -88 77 -89 29 -1 94
90 94 131 0 29 -30 104 -47 117 -22 16 -54 15 -80 -3z"/>
<path d="M2590 3290 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0
-15 -4 -15 -10z"/>
</g>
</svg>
    )
}
export default SplatterFour;